import {Component, Input} from '@angular/core';

@Component({
    selector: 'scitis-loading-items',
    templateUrl: './loading-items.component.html',
    styleUrls: ['./loading-items.component.scss'],
    standalone: false
})
export class LoadingItemsComponent {

  @Input()
  display: boolean = false;

}
